module.exports = __webpack_public_path__ + "static/img/zuo.91addda.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/zuo.png
// module id = W+cj
// module chunks = 1